import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, isRef as _isRef, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-193945ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "graph-header" }
const _hoisted_2 = { class: "date-time-selector" }
const _hoisted_3 = { class: "graph-pagination" }
const _hoisted_4 = { class: "graph-btns" }

import { computed, ref, watch, PropType } from 'vue'
import moment from 'moment'
import { camelCase } from 'lodash'
import DatePicker from '@/components/graph/DatePicker.vue'
import Selector from '@/components/graph/Selector.vue'
import { useInitDataStore } from '@/stores/initDataStore'
import { DefinitionInfoGraphListItemItemItem } from '@/models/initData/DefinitionInfo'
import { XRange, XRangeType } from '@/lib/graph/types/initResult'
import { GraphTypeField } from '@/lib/graph/types/graphData'


export default /*#__PURE__*/_defineComponent({
  props: {
  center: {
    type: Number,
    required: true,
  },

  field: {
    type: Object as PropType<GraphTypeField>,
    reuquired: true,
  },
},
  emits: ['update:field', 'update:center', 'toggleWindRateCount'],
  setup(__props, { emit }) {

const props = __props




const picked = ref(moment(props.center).toDate())
const currentField = ref(props.field as GraphTypeField)
const initDataStore = useInitDataStore()
const currentReportType = computed(() => {
  return currentField.value?.reportType || currentField.value.items?.[0].type
})
const disabledPdf = computed(() => {
  return initDataStore.initData.definitionInfo.graph.common.disabledPdf
})
// 多要素グラフかどうか
const isWeatherGraph = computed(() => {
  return props.field?.stationId !== undefined
})
const toggleWindRateCount = () => {
  emit('toggleWindRateCount')
}

watch(
  () => picked.value,
  () => {
    emit('update:center', picked.value.getTime())
  }
)

watch(
  () => props.center,
  () => {
    picked.value = new Date(props.center)
  }
)

const modelCenter = computed({
  get: () => picked.value.getTime(),
  set: (value: number) => (picked.value = new Date(value)),
})

const select = (item: DefinitionInfoGraphListItemItemItem) => {
  currentField.value = {
    selectedId: camelCase(item.target),
    reportType: item.type,
    title: item.title,
    stationId: item.stationId,
    items: item.items,
  }

  emit('update:field', currentField.value)
}

const paginate = (reportType?: XRangeType, isPrevious?: boolean) => {
  const center = props.center
  switch (reportType) {
    case XRange.HOUR:
    case XRange.DAY:
      picked.value = isPrevious
        ? moment(center).subtract(1, 'days').set('hour', 12).startOf('hour').toDate()
        : moment(center).add(1, 'days').set('hour', 12).startOf('hour').toDate()
      break
    case XRange.MONTH:
      picked.value = isPrevious
        ? moment(center).subtract(1, 'months').set('date', 16).startOf('date').toDate()
        : moment(center).add(1, 'months').set('date', 16).startOf('date').toDate()
      break
    case XRange.YEAR:
      picked.value = isPrevious
        ? moment(center).subtract(1, 'years').set('month', 6).startOf('month').toDate()
        : moment(center).add(1, 'years').set('month', 6).startOf('month').toDate()
      break
    default:
      break
  }
  emit('update:center', picked.value.getTime())
}

const currentTime = (rangeType?: XRangeType) => {
  let now = moment()
  const hour = now.hour()
  switch (rangeType) {
    case XRange.HOUR:
      now = now.set('hour', Math.floor(hour / 8) * 8 + 4).startOf('hour')
      break
    case XRange.DAY:
      now = now.set('hour', 12)
      break
    case XRange.MONTH:
      now = now.set('date', 16)
      break
    case XRange.YEAR:
      now = now.set('month', 6).endOf('month')
      break
  }
  picked.value = now.toDate()
  emit('update:center', picked.value.getTime())
}

const getPaginateTxt = (isPrevious: boolean) => {
  switch (currentReportType.value) {
    case 'hour':
    case 'day':
      return isPrevious ? '前日' : '翌日'
    case 'month':
      return isPrevious ? '前月' : '翌月'
    case 'year':
      return isPrevious ? '前年' : '翌年'
    default:
      return ''
  }
}

const getCurrentTxt = () => {
  switch (currentReportType.value) {
    case 'hour':
    case 'day':
      return '今日'
    case 'month':
      return '今月'
    case 'year':
      return '今年'
    default:
      return ''
  }
}

const print = () => {
  window.print()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(Selector, { onSelect: select }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DatePicker, {
        center: _unref(modelCenter),
        "onUpdate:center": _cache[0] || (_cache[0] = ($event: any) => (_isRef(modelCenter) ? (modelCenter).value = $event : null)),
        reportType: _unref(currentReportType)
      }, null, 8, ["center", "reportType"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "graph-pagination-button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (paginate(_unref(currentReportType), true)))
        }, _toDisplayString(getPaginateTxt(true)), 1),
        _createElementVNode("button", {
          class: "graph-pagination-button",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (currentTime(_unref(currentReportType))))
        }, _toDisplayString(getCurrentTxt()), 1),
        _createElementVNode("button", {
          class: "graph-pagination-button",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (paginate(_unref(currentReportType), false)))
        }, _toDisplayString(getPaginateTxt(false)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_unref(isWeatherGraph) && _unref(currentReportType) !== 'hour')
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: toggleWindRateCount,
            class: "button"
          }, " 風向頻度グラフ表示 "))
        : _createCommentVNode("", true),
      (!_unref(disabledPdf))
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "icon-button print",
            onClick: print
          }, "印刷"))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})